import { createSubscription, createUserAndSubscription } from './backend';
import getStripe from '../stripe.js';

const buildLoginParams = (response, formUser) => {
  let email = encodeURIComponent(formUser.email);
  return { loginUrl: `${__ZUUL_URL}/consumer_search?user_email=${email}&user_token=${response.user.token}` };
}

const authenticateCard = async (setupIntent, card, firstName, lastName) => {
  const stripe = await getStripe()
  const cardDetails = { payment_method: { card, billing_details: { name: `${firstName} ${lastName}` } } }
  const response = await stripe.confirmCardSetup(setupIntent.client_secret, cardDetails)

  if (response.error) {
    throw { card_number: response.error.message }
  }

  return setupIntent
}

export const subscribe = async (user, setupIntentArg, formData, priceId, card) => {
  const setupIntent = await authenticateCard(setupIntentArg, card, formData.first_name, formData.last_name);
  const payload = { ...formData, intent_id: setupIntent.id, plan_code: priceId };
  const createSubFn = user.isZuulUser ? createSubscription : createUserAndSubscription;
  const response = await createSubFn(payload);
  if (user.isZuulUser) return {};
  return buildLoginParams(response, formData);
}